export default "__VITE_ASSET__BnAMrwRc__"